export default {
  en: {
    supplementChargeList: 'Supplement Charge List',
    editSupplementCharge: 'Edit Supplement Charge',
    name: 'Name',
    type: 'Type',
    pleaseSelectType: 'Please select type',
    otherType: '- Other -',
    rate: 'Rate',
    unit: 'Unit',
    inRomRate: 'In room rate',
    yes: 'Yes',
    no: 'No',
    periodOfStay: 'Period of Stay',
    addPeriod: 'Add Period',
    conditionDetail: 'Condition Detail',
    updateSupplementCharge: 'Save Changes',
    cancel: 'Cancel',
    updateSupplementChargeSuccessTitle: 'Success',
    updateSupplementChargeSuccessMessage: 'Add supplement charge success.',
    pleaseSelectPeriodOfStay: 'Please select period of stay',
    alertOverlap: 'Period is Overlap',
    allTheTime: 'All'
  },
  th: {
    supplementChargeList: 'Supplement Charge List',
    editSupplementCharge: 'Edit Supplement Charge',
    name: 'ชื่อ',
    type: 'ประเภท',
    pleaseSelectType: 'กรุณาเลือกประเภท',
    otherType: '- อื่นๆ -',
    rate: 'ราคา',
    unit: 'หน่วย',
    inRomRate: 'รวมในราคาห้อง',
    yes: 'Yes',
    no: 'No',
    periodOfStay: 'ช่วงเวลา',
    addPeriod: 'เพิ่มช่วงเวลา',
    conditionDetail: 'รายละเอียด',
    updateSupplementCharge: 'บันทึก',
    cancel: 'ยกเลิก',
    updateSupplementChargeSuccessTitle: 'สำเร็จ',
    updateSupplementChargeSuccessMessage: 'แก้ไข Supplement Charge สำเร็จ.',
    pleaseSelectPeriodOfStay: 'กรุณาเลือกช่วงเวลา',
    alertOverlap: 'ช่วงเวลาซ้อนทับกัน',
    allTheTime: 'ตลอดระยะสัญญา'
  }
}
